export default "__VITE_ASSET__DJPbtBrN__"